module.exports = __webpack_public_path__ + "static/img/juan-wl.61443aa8.png";